<template>
  <v-container fluid>
    <OverviewCardsVT
      :config="page_content.location_overview"
      :values="location_overview_stats"
      @card-click="filter_locations_devices($event)"
    />

    <v-row class="common-card-row">
      <v-col class="common-card-col">
        <v-col cols="12 d-flex ">
          <v-card
            :width="
              show_map_view ||
              current_filter == 'Outside Pois' ||
              current_filter == 'No Location' ||
              current_tab == 'Possible-Pois'
                ? '50%'
                : '100%'
            "
            class="mr-1 backgroundWhite"
            flat
          >
            <v-row v-if="current_filter != 'Outside Pois' && current_filter != 'No Location'" class="backgroundWhite">
              <v-col cols="12" sm="8">
                <PrimaryFiltersVT
                  :list_filters="page_content.filters.primary"
                  @filter_update="filter_list($event)"
                  :current_tab="current_tab"
                ></PrimaryFiltersVT>
              </v-col>
              <v-col cols="12" sm="4" v-if="current_tab != 'Possible-Pois'" class="text-right">
                <SecondaryFiltersVT
                  :default="filter_conditions"
                  :filters="page_content.filters.secondary"
                  @clear_filters="clear_filters"
                  @apply_filters="apply_filters($event)"
                ></SecondaryFiltersVT>
                <v-btn
                  v-if="!show_map_view"
                  class="mr-2 text-capitalize"
                  depressed
                  small
                  @click="show_map_view = !show_map_view"
                >
                  <v-icon left>mdi-map-legend</v-icon>Show Map
                </v-btn>
              </v-col>
            </v-row>
            <DataTableVT
              v-if="
                !show_map_view &&
                current_filter != 'Outside Pois' &&
                current_filter != 'No Location' &&
                current_tab != 'Possible-Pois'
              "
              :headers="page_content.locations_table"
              :items_list="location_data"
              item_key="LocationID"
              sort_by="TotalAssets"
              @rowClick="open_details($event)"
              @add-to-list="watchlist_update($event)"
              @action="table_actions($event)"
              :loading="is_loading"
            />
            <div
              v-if="
                show_map_view &&
                current_filter != 'Outside Pois' &&
                current_filter != 'No Location' &&
                current_tab != 'Possible-Pois'
              "
              class="fixed-height"
            >
              <div class="mb-4 d-flex" v-if="selected_poi && selected_poi.length > 0">
                <v-spacer></v-spacer>
                <v-btn
                  class="mr-2"
                  outlined
                  x-small
                  color="primary"
                  @click="
                    selected_poi = [];
                    toggle_clicked_marker();
                  "
                >
                  Clear
                </v-btn>
              </div>
              <v-data-iterator
                item-key="LocationID"
                :items="location_data"
                :items-per-page="10"
                :single-select="true"
                :search="selected_poi[0]"
                :custom-filter="toggle_clicked_marker"
                sort-by="TotalAssets"
                sort-desc
                :loading="is_loading"
              >
                <template v-slot:default="props">
                  <v-row no-gutters class="pointer px-2">
                    <v-col
                      :id="`data-card-${item.id}`"
                      :ref="`data-card-${item.id}`"
                      :class="`border-bottom py-2 px-4 ${
                        selected_poi &&
                        selected_poi.length > 0 &&
                        item.id &&
                        selected_poi.indexOf(item.id.toString()) != -1
                          ? 'selected-item'
                          : ''
                      }`"
                      cols="12"
                      v-for="item in props.items"
                      :key="item.LocationID"
                      @click="open_details(item)"
                    >
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-row no-gutters>
                            <v-col cols="10" class="text-subtitle-2 text-capitalize">
                              {{ $emptyCheck(item.FullName.toLowerCase()) }}
                              <span class="text-caption primaryGrey--text">
                                {{ `${item.LocationCategory ? "- " + item.LocationCategory : ""}` }}
                              </span>
                            </v-col>
                            <v-col cols="2">
                              <v-btn icon color="primaryOutline" v-on:click.stop="watchlist_update(item)">
                                <v-icon>{{ item.IsWatchlisted ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                              </v-btn>
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    x-small
                                    class="py-4 px-1"
                                    color="restingOutline"
                                  >
                                    <v-icon color="primaryGrey">mdi-dots-horizontal</v-icon>
                                  </v-btn>
                                </template>
                                <v-list dense>
                                  <v-list-item @click="table_actions({ item: item })">
                                    <v-list-item-title>Edit Details</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-row class="mt-1" no-gutters>
                            <v-col cols="3">
                              <div class="primaryGrey--text text-caption">Rate of Flow</div>
                              <div class="text-body-2">
                                {{ $percentage(item.FlowRate) }}
                              </div>
                            </v-col>
                            <v-col cols="3">
                              <div class="primaryGrey--text text-caption">Avg. Stay Duration</div>
                              <div class="text-body-2">
                                {{ item.Utilisation | timeSince }}
                              </div>
                            </v-col>
                            <v-col cols="2" class="border-right">
                              <div class="primaryGrey--text text-caption">Total Assets</div>
                              <div class="text-subtitle-1 font-weight-bold">
                                {{ item.TotalAssets ? item.TotalAssets : "-" }}
                              </div>
                            </v-col>
                            <v-col cols="4" class="pr-3 pl-5">
                              <div class="primaryGrey--text text-caption">Assets Allocation</div>
                              <div class="mr-5 pt-2">
                                <DistributionBarVT
                                  :values="page_content.AssetAllocation.values"
                                  :item="item"
                                  :colors="page_content.AssetAllocation.colors"
                                  :labels="page_content.AssetAllocation.labels"
                                />
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </div>
            <div class="fixed-height">
              <div
                class="my-4 mr-3 d-flex"
                v-if="
                  (selected_poi &&
                    selected_poi.length > 0 &&
                    (current_filter == 'Outside Pois' || current_filter == 'No Location')) ||
                  (selected_possible_pois && current_tab == 'Possible-Pois')
                "
              >
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  x-small
                  color="primary"
                  @click="
                    selected_possible_pois = null;
                    selected_poi = [];
                    toggle_clicked_marker();
                  "
                >
                  Clear
                </v-btn>
              </div>
              <DataTableVT
                v-if="current_filter == 'Outside Pois'"
                :headers="page_content.devices_table"
                :items_list="filtered_unspec_devices"
                :loading="is_loading"
              />
              <DataTableVT
                v-if="current_filter == 'No Location'"
                :headers="page_content.unknown_devices_table"
                :items_list="filtered_unknwn_devices"
                :loading="is_loading"
              />
              <DataTableVT
                v-if="
                  current_filter != 'Outside Pois' && current_filter != 'No Location' && current_tab == 'Possible-Pois'
                "
                :headers="page_content.possible_pois_table"
                :items_list="filtered_possible_pois_list"
                :loading="is_loading"
                @action="show_location_on_map($event)"
              />
            </div>
          </v-card>
          <v-card
            flat
            width="50%"
            class="ml-1 backgroundWhite"
            v-if="
              show_map_view ||
              current_filter == 'Outside Pois' ||
              current_filter == 'No Location' ||
              current_tab == 'Possible-Pois'
            "
          >
            <v-row>
              <v-col cols="12" class="py-0">
                <v-btn
                  v-if="
                    current_filter != 'Outside Pois' &&
                    current_filter != 'No Location' &&
                    current_tab != 'Possible-Pois'
                  "
                  @click="
                    show_map_view = !show_map_view;
                    current_filter = '';
                  "
                  x-small
                  class="py-5 ma-2 map-close-button"
                  outlined
                  color="borderDark"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <MapsVT
                  v-if="map_data && current_tab != 'Possible-Pois'"
                  :options="page_content.maps_config"
                  :legends="$config.map_legends"
                  :items="map_data"
                  height="70vh"
                  :clusterMarkers="clusterMarkers"
                  :map_click="show_info_window"
                  :radius="radius"
                  @map-click="map_clicked($event)"
                  @marker_clicked="marker_clicked($event)"
                  @filter="filter_map_data($event)"
                  :selected="selected"
                ></MapsVT>
                <MapsVT
                  v-if="
                    current_tab == 'Possible-Pois' &&
                    current_filter != 'Outside Pois' &&
                    current_filter != 'No Location' &&
                    formatted_possible_pois_list
                  "
                  :options="page_content.maps_config_possible_pois"
                  :items="formatted_possible_pois_list"
                  height="70vh"
                  :clusterMarkers="clusterMarkers"
                  @marker_clicked="marker_clicked($event)"
                  :selected="selected"
                  :new_item="show_map_object"
                ></MapsVT>
              </v-col>
            </v-row>
          </v-card>
          <v-overlay class="layering" :value="dialog">
            <v-card
              :light="!this.$vuetify.theme.dark"
              class="backgroundLight"
              style="width: 80vw; max-height: 80vh; overflow: auto"
            >
              <div class="close-btn">
                <v-btn class="py-4" outlined x-small color="restingOutline" right @click="closeDialog">
                  <v-icon small color="primaryGrey">close</v-icon>
                </v-btn>
              </div>
              <div class="pa-0" style="overflow: auto; height: 100%; max-width: 100%">
                <Location v-if="overlay_type == 'details'" :location_detail="location_details" />
                <EditLocationDetails
                  v-if="overlay_type == 'edit' || overlay_type == 'new'"
                  :overlay_type="overlay_type"
                  :location_categories="location_categories"
                  @save="update_location_details($event)"
                  @add="add_new_poi($event)"
                  @cancel="dialog = false"
                  :location_detail="location_details"
                />
              </div>
            </v-card>
          </v-overlay>
        </v-col>
      </v-col>
    </v-row>
    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ error_message }}</v-snackbar>
  </v-container>
</template>

<script>
import Location from "../views/Location";
import DataTableVT from "../components/DataTableVT";
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import SecondaryFiltersVT from "../components/SecondaryFiltersVT";
import OverviewCardsVT from "../components/OverviewCardsVT";
import MapsVT from "../components/MapsVT";
import DistributionBarVT from "../components/DistributionBarVT";
import EditLocationDetails from "../components/EditLocationDetails";
import { axios_get, axios_post, axios_put, axios_delete } from "../services/vt_service";
import { tracking } from "../services/tracking";
import { fn } from "../services/utility";
import { content } from "../../config/locations.js";
import { redirect_to_asset } from "../helpers/helpers";

export default {
  name: "LocationList",
  components: {
    Location,
    DataTableVT,
    PrimaryFiltersVT,
    SecondaryFiltersVT,
    OverviewCardsVT,
    MapsVT,
    DistributionBarVT,
    EditLocationDetails,
  },
  watch: {
    locations_data: function (newVal) {
      if (newVal) {
        this.get_location_data();
      }
    },
  },
  data: function () {
    return {
      is_loading: false,
      snackbar: false,
      page_content: null,
      location_details: {},
      network_error: false,
      copy_location_data: [],
      location_data: [],
      stats_data: [],
      error_message: "",
      formated_location_data: null,
      locations_array: [],
      panel: [],
      search: "",
      dialog: false,
      expanded: [],
      current_sort_dir: "asc",
      current_sort: "LocationName",
      location_overview_stats: {},
      watchlist: [],
      show_map_view: false,
      filter_conditions: {},
      primary_filter_conditions: "",
      overlay_type: "",
      current_filter: "",
      unspecified_id: "",
      no_location_id: "",
      unspecified_devices: [],
      unknown_devices: [],
      radius: 500,
      location_categories: null,
      selected: ["All"],
      clusterMarkers: true,
      selected_poi: [],
      selected_possible_pois: null,
      current_tab: "All",
      possible_pois_list: [],
      show_map_object: null,
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    // this.$store.commit("update_page_title", "Point Of Interest (POIs)");
    this.get_location_data();
    this.get_LocationCategory();
  },
  filters: {},
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    filter_locations_devices(filter) {
      this.is_loading = true;
      this.location_data = [];
      this.selected_poi = [];
      this.unknown_devices = [];
      this.unspecified_devices = [];
      this.selected = [filter];
      this.current_filter = filter;
      this.current_tab = null;
      if (filter == "Outside Pois") {
        this.show_unspeified_devices(this.unspecified_id, "outside");
      } else if (filter == "No Location") {
        this.show_unspeified_devices(this.no_location_id, "unknown");
      } else this.filter_list(filter);
    },
    clear_filters: function () {
      this.filter_conditions = {};
      this.filter_list("All");
    },
    apply_filters: function (filters) {
      this.filter_conditions = filters;
      this.filter_list(this.current_tab || "All");
    },
    open_details(location_obj) {
      if (location_obj.ctrlKey) return redirect_to_asset(this.$router, "Location", location_obj.LocationID);
      this.location_details = location_obj;
      this.overlay_type = "details";
      this.dialog = true;
    },
    table_actions(location_obj) {
      if (location_obj.action === "OpenAsPage")
        return redirect_to_asset(this.$router, "Location", location_obj.item.LocationID);
      this.location_details = location_obj;
      this.overlay_type = "edit";
      this.dialog = true;
    },
    filter_map_data(data) {
      this.location_data = [];
      this.selected = data;
      if (data.indexOf("All") != -1 || (data.indexOf("Friendly") != -1 && data.indexOf("Non-Friendly") != -1)) {
        this.filter_list("All");
      } else if (data.indexOf("Friendly") != -1) {
        this.filter_list("Friendly");
      } else if (data.indexOf("Non-Friendly") != -1) {
        this.filter_list("Non-Friendly");
      }
      if (data.indexOf("Outside Pois") != -1) this.show_unspeified_devices(this.unspecified_id, "outside");
      if (data.indexOf("No Location") != -1) this.show_unspeified_devices(this.no_location_id, "unknown");
    },
    watchlist_update(item) {
      item["IsWatchlisted"] ? this.delete_from_watchlist(item) : this.add_to_watchlist(item);
    },
    toggle_clicked_marker() {
      // if (this.selected_poi && this.selected_poi[0] && this.location_data)
      return this.location_data.filter((elem) => {
        return this.selected_poi && this.selected_poi[0] ? elem.id == this.selected_poi[0] : true;
      });
      // else return this.location_data;
    },
    async get_LocationCategory() {
      const response = await axios_get(tracking.get_LocationCategory);
      this.location_categories = response
        .map((elem) => {
          if (elem.LocationCategory) return elem.LocationCategory;
        })
        .filter((elem) => {
          if (elem) return elem;
        });
      this.page_content.filters.secondary["list_checkbox"][0].values = this.location_categories;
    },
    async get_possible_pois() {
      if (this.possible_pois_list.length > 0) return;
      const response = await axios_get(tracking.get_possible_pois);
      this.possible_pois_list = response;
    },
    async add_new_poi(location_obj) {
      if (!location_obj["LocationCategory"] || !location_obj["LocationCategory"].trim())
        location_obj["LocationCategory"] = null;
      this.dialog = false;
      await axios_post(tracking.add_new_poi, location_obj);
      this.error_message = "POI Added Successfully!";
      this.snackbar = true;
    },
    show_location_on_map(obj) {
      this.show_map_object = obj[1];
    },
    map_clicked(data) {
      let position = data[0];
      let radius = data[1];
      this.location_details = {
        item: {
          Latitude: position.lat,
          Longitude: position.lng,
          Radius: radius,
        },
      };
      this.dialog = true;
      this.overlay_type = "new";
    },
    async show_unspeified_devices(id, type) {
      this.copy_location_data = JSON.parse(JSON.stringify(this.location_data));
      this.network_error = false;
      const response = await axios_get(tracking.fetch_devices_at_POI, { id });
      if (type == "outside") {
        this.unspecified_devices = response;
      } else {
        this.unknown_devices = response;
      }
      this.is_loading = false;
    },
    get_position(lat, lng) {
      return {
        lat: lat,
        lng: lng,
      };
    },
    get_icon(isWatchlisted) {
      return isWatchlisted
        ? "http://maps.google.com/mapfiles/kml/paddle/blu-stars.png"
        : "http://maps.google.com/mapfiles/kml/paddle/blu-blank.png";
    },
    filterDeviceList(value, search, item) {
      return (
        (item != null && search != null && item.DeviceID.toLowerCase().includes(this.search.toLowerCase())) ||
        item.LocationName.toLowerCase().includes(this.search.toLowerCase()) ||
        item.LocationType.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    formatLocationData: function () {
      var categorizedObject = this.location_data.reduce((acc, ele) => {
        acc[ele.LocationName] = acc[ele.LocationName] || {
          LocationName: ele.LocationName,
          LocationType: ele.LocationType,
          devices: [],
        };
        acc[ele.LocationName].devices.push(ele);
        return acc;
      }, {});
      this.formated_location_data = Object.values(categorizedObject);
    },
    async update_location_details(data) {
      this.dialog = false;
      this.network_error = false;
      const {
        LocationID,
        FullName,
        LocationAddress1,
        LocationCategory,
        LocationType,
        ShortName,
        Latitude,
        Longitude,
        Comment,
        Radius,
      } = data;
      await axios_put(tracking.update_location_details, { LocationID }, data);
      this.error_message = "POI Details Successfully Saved!";
      this.location_data = this.location_data.map((elem) => {
        if (elem.LocationID == LocationID) {
          elem = {
            ...elem,
            FullName,
            LocationAddress1,
            LocationCategory,
            LocationType,
            ShortName,
            Latitude,
            Longitude,
            Comment,
            Radius,
          };
        }
        return elem;
      });
      this.snackbar = true;
    },
    async delete_from_watchlist(item) {
      this.network_error = false;
      await axios_delete(tracking.delete_from_watchlist_location, { id: item["LocationID"] });
      this.watchlist.splice(this.watchlist.indexOf(item["LocationID"]), 1);
      this.location_data = this.location_data.map((elem) => {
        if (elem.LocationID == item.LocationID) elem.IsWatchlisted = false;
        return elem;
      });
    },
    async filter_list(filter) {
      this.current_tab = filter;
      if (filter == "Possible-Pois") {
        this.get_possible_pois();
        return;
      }
      // this.copy_location_data = [];
      if (filter) this.primary_filter_conditions = filter;
      var params = {};
      const keys =
        (this.filter_conditions &&
          this.filter_conditions.checkbox &&
          Object.keys(this.filter_conditions["checkbox"])) ||
        [];
      keys.forEach((key) => {
        if (this.filter_conditions["checkbox"][key] && this.filter_conditions["checkbox"][key].length > 0)
          params[key] = this.filter_conditions["checkbox"][key].toString();
      });
      var fil = this.page_content.filters.primary.filter((elem) => {
        return elem.value == filter;
      });
      fil = fil && fil.length == 1 ? fil.map((e) => e.value) : null;
      this.network_error = false;
      const location_res = await axios_get(tracking.get_location_data, { num_days: 1 }, params);
      const stats_res = await axios_get(tracking.get_location_stats);
      const watchlist_res = await axios_get(tracking.get_watchlisted_locations);
      this.location_data = fn.merge_locations_obj(location_res, stats_res, watchlist_res);
      if (this.location_data.length > 0) {
        let range_filter = {};
        let range_keys =
          this.filter_conditions && this.filter_conditions["range"] && Object.keys(this.filter_conditions["range"]);
        for (let i = 0; i < (range_keys && range_keys.length) || 0; i++) {
          let temp = range_keys[i].split("_");
          let field = temp[1];
          range_filter[temp[0]] = range_filter[temp[0]] || {};
          range_filter[temp[0]][field] =
            temp[0] == "FlowRate"
              ? this.filter_conditions["range"][range_keys[i]] / 100
              : this.filter_conditions["range"][range_keys[i]];
        }
        this.location_data = this.location_data
          .map((elem) => {
            elem.IsWatchlisted = this.watchlist.indexOf(elem.LocationID) != -1 ? true : false;
            return elem;
          })
          .filter((elem) => {
            let filtered =
              (fil.indexOf("Watchlist") != -1 && elem.IsWatchlisted == true) ||
              (fil.indexOf("Friendly") != -1 && elem.LocationType.toLowerCase().trim() == "friendly") ||
              (fil.indexOf("Non-Friendly") != -1 &&
                elem.LocationType.toLowerCase().trim() != "friendly" &&
                elem.LocationType.toLowerCase().includes("friendly")) ||
              fil.indexOf("All") != -1;
            let filter = Object.keys(range_filter);
            for (let i = 0; i < filter.length; i++) {
              if (!(range_filter[filter[i]]["min"] == 0 && range_filter[filter[i]]["max"] == 0))
                filtered =
                  filtered &&
                  elem[filter[i]] >= range_filter[filter[i]]["min"] &&
                  elem[filter[i]] <= range_filter[filter[i]]["max"];
            }
            return filtered;
          });
      }
      this.is_loading = false;
    },
    async add_to_watchlist(item) {
      var data = { LocationID: item["LocationID"] };
      this.network_error = false;
      await axios_post(tracking.add_to_watchlist_location, data);
      this.location_data = this.location_data.map((elem) => {
        if (elem.LocationID == item.LocationID) elem.IsWatchlisted = true;
        return elem;
      });
      this.watchlist.push(item["LocationID"]);
    },
    async get_location_data() {
      if (this.locations_data) this.location_data = JSON.parse(JSON.stringify(this.$store.state.locations));
      this.get_overview_stats();
    },
    get_overview_stats() {
      this.location_overview_stats = {
        Friendly: {
          locations: 0,
          devices: 0,
        },
        "Non-Friendly": {
          locations: 0,
          devices: 0,
        },
        All: {
          locations: this.location_data.length,
          devices: 0,
        },
        "Outside Pois": {
          locations: 0,
          devices: 0,
        },
        "No Location": {
          locations: 0,
          devices: 0,
        },
      };
      var type = "";
      this.location_data.map((elem) => {
        type = elem.LocationType.toLowerCase().includes("friendly")
          ? elem.LocationType.toLowerCase().trim() == "friendly"
            ? "Friendly"
            : "Non-Friendly"
          : elem.LocationType.toLowerCase().includes("outside")
            ? "Outside Pois"
            : "No Location";
        if (elem.LocationType.toLowerCase().trim() == "outside pois") {
          this.unspecified_id = elem.LocationID;
          // this.show_unspeified_devices(this.unspecified_id, "outside");
        } else if (elem.LocationType.toLowerCase().trim() == "no location data") {
          this.no_location_id = elem.LocationID;
          // this.show_unspeified_devices(this.no_location_id, "unknown");
        }
        this.location_overview_stats[type].locations++;
        this.location_overview_stats[type].devices += elem.TotalAssets || 0;
        this.location_overview_stats["All"].devices += elem.TotalAssets || 0;
      });
    },
    marker_clicked(obj) {
      if (this.current_tab == "Possible-Pois") {
        this.selected_possible_pois = obj[0];
        return;
      }
      this.selected_poi = [obj[0]];
    },
    update_locations_watchlist() {
      this.location_data.map((elem) => {
        elem.IsWatchlisted = this.watchlist.indexOf(elem.LocationID) != -1 ? true : false;
        return elem;
      });
      this.copy_location_data = JSON.parse(JSON.stringify(this.location_data));
    },
  },
  computed: {
    user_account: function () {
      return this.$auth.user;
    },
    filtered_location: function () {
      return this.location_data.filter((loc) => {
        return loc.Latitude && loc.Longitude;
      });
    },
    all_devices: function () {
      let temp_locations = [];
      let distinct_location = {};
      let known_locations = [];
      this.unspecified_devices.map((elem) => {
        if (temp_locations.indexOf(elem.CurrentLat + "," + elem.CurrentLng) == -1) {
          temp_locations.push(elem.CurrentLat + "," + elem.CurrentLng);
          distinct_location[elem.CurrentLat + "," + elem.CurrentLng] = [];
        }
        distinct_location[elem.CurrentLat + "," + elem.CurrentLng].push({
          TotalAssets: elem["TotalAssets"],
          CurrentLat: elem["CurrentLat"],
          LocationType: "outside",
          CurrentLng: elem["CurrentLng"],
          DeviceID: elem["DeviceID"],
        });
      });
      Object.keys(distinct_location).forEach((key) => {
        let temp = distinct_location[key][0];
        temp["TotalAssets"] = distinct_location[key].length;
        temp["markerType"] = "device_outside";
        if (distinct_location[key].length > 1) {
          var name = [];
          for (let l = 0; l < distinct_location[key].length; l++) {
            name.push(distinct_location[key][l].DeviceID);
          }
          temp["name"] = name;
          temp["id"] = name;
        } else {
          temp["name"] = distinct_location[key][0]["DeviceID"];
          temp["id"] = distinct_location[key][0]["DeviceID"];
        }
        known_locations.push(temp);
      });
      return this.unspecified_devices ? known_locations : [];
    },
    show_info_window: function () {
      return this.current_filter == "Outside Pois" ? true : false;
    },
    no_location_devices: function () {
      let temp_locations = [];
      let distinct_location = {};
      let unknown_locations = [];
      this.unknown_devices.map((elem) => {
        let is_outside = false;
        if (elem.LastKnownPOI.toLowerCase().includes("outside")) {
          is_outside = true;
          unknown_locations.push({
            LastKnownPOI: elem["LastKnownPOI"],
            CurrentLat: elem["LastLatAtKnownLocation"],
            LocationType: "outside",
            CurrentLng: elem["LastLngAtKnownLocation"],
            DeviceID: elem["DeviceID"],
            name: elem["DeviceID"],
            id: elem["DeviceID"],
            markerType: "device_unknown",
          });
        }
        if (!is_outside && temp_locations.indexOf(elem.LastKnownPOI) == -1) {
          temp_locations.push(elem.LastKnownPOI);
          distinct_location[elem.LastKnownPOI] = [];
        }
        if (!is_outside) {
          distinct_location[elem.LastKnownPOI].push({
            LastKnownPOI: elem["LastKnownPOI"],
            CurrentLat: elem["LastLatAtKnownLocation"],
            LocationType: elem["LastLocationTypeAtKnownLocation"],
            CurrentLng: elem["LastLngAtKnownLocation"],
            DeviceID: elem["DeviceID"],
            markerType: "location_" + elem["LastLocationTypeAtKnownLocation"],
          });
        }
      });
      Object.keys(distinct_location).forEach((key) => {
        let temp = distinct_location[key][0];
        temp["TotalAssets"] = distinct_location[key].length;
        if (distinct_location[key].length > 1) {
          var name = [];
          for (let l = 0; l < distinct_location[key].length; l++) {
            name.push(distinct_location[key][l].DeviceID);
          }
          temp["name"] = name;
          temp["id"] = name;
        } else {
          temp["name"] = distinct_location[key][0]["DeviceID"];
          temp["id"] = distinct_location[key][0]["DeviceID"];
        }
        unknown_locations.push(temp);
      });
      return this.unknown_devices ? unknown_locations : [];
    },
    map_data: function () {
      return this.no_location_devices.concat(this.filtered_location).concat(this.all_devices);
    },
    filtered_unspec_devices: function () {
      return (
        this.unspecified_devices &&
        this.unspecified_devices.filter((elem) => {
          let ids = this.selected_poi && this.selected_poi.length > 0 && this.selected_poi[0].split(",");
          return this.selected_poi && this.selected_poi.length > 0 ? ids.indexOf(elem.DeviceID) != -1 : true;
        })
      );
    },
    filtered_unknwn_devices: function () {
      return (
        this.unknown_devices &&
        this.unknown_devices.filter((elem) => {
          let ids = this.selected_poi && this.selected_poi.length > 0 && this.selected_poi[0].split(",");
          return this.selected_poi && this.selected_poi.length > 0 ? ids.indexOf(elem.DeviceID) != -1 : true;
        })
      );
    },
    locations_data: function () {
      return this.$store.state.locations ? this.$store.state.locations : null;
    },
    formatted_possible_pois_list: function () {
      return this.possible_pois_list
        ? this.possible_pois_list.map((elem, indx) => {
            elem["id"] = indx + 1;
            elem["DeviceList"] = elem["DeviceList"].split(",").map((e) => e.trim());
            return elem;
          })
        : [];
    },
    filtered_possible_pois_list: function () {
      return this.formatted_possible_pois_list
        ? this.formatted_possible_pois_list.filter((elem) => {
            return this.selected_possible_pois ? elem.id == this.selected_possible_pois : true;
          })
        : [];
    },
  },
};
</script>
<style scoped lang="scss">
.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}
.map-close-button {
  position: absolute;
  z-index: 5;
}
.border-right {
  border-right: 1px solid var(--v-primaryGrey-base);
}
.border-bottom {
  border-bottom: 1px solid var(--v-primaryGrey-base);
}
div.selected-item {
  border: 2px solid var(--v-primaryGrey-base);
  border-radius: 5px;
  // outline: 1px solid var(--v-primaryGrey-base);
}
.fixed-height {
  max-height: 70vh;
  overflow: auto;
}
.pointer {
  cursor: pointer;
}
</style>
